var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#8247E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5645 10.666C16.3062 10.5138 15.9704 10.5138 15.6864 10.666L13.6716 11.833L12.3026 12.5941L10.2878 13.7611C10.0295 13.9133 9.6937 13.9133 9.40962 13.7611L7.80812 12.8478C7.54981 12.6955 7.369 12.4165 7.369 12.112V10.3108C7.369 10.0063 7.52398 9.72726 7.80812 9.57508L9.38375 8.68708C9.64203 8.53491 9.97785 8.53491 10.262 8.68708L11.8376 9.57508C12.0959 9.72726 12.2767 10.0063 12.2767 10.3108V11.4778L13.6457 10.6913V9.52431C13.6457 9.21988 13.4908 8.94081 13.2066 8.78856L10.2878 7.11417C10.0295 6.96194 9.6937 6.96194 9.40962 7.11417L6.43912 8.78856C6.15498 8.94081 6 9.21988 6 9.52431V12.8986C6 13.203 6.15498 13.4821 6.43912 13.6343L9.40962 15.3087C9.6679 15.4609 10.0036 15.4609 10.2878 15.3087L12.3026 14.167L13.6716 13.3806L15.6864 12.2389C15.9446 12.0867 16.2804 12.0867 16.5645 12.2389L18.1402 13.1269C18.3984 13.2791 18.5793 13.5582 18.5793 13.8626V15.6638C18.5793 15.9683 18.4243 16.2474 18.1402 16.3996L16.5645 17.3129C16.3062 17.4652 15.9704 17.4652 15.6864 17.3129L14.1107 16.425C13.8524 16.2727 13.6716 15.9937 13.6716 15.6892V14.5222L12.3026 15.3087V16.4757C12.3026 16.7801 12.4576 17.0592 12.7417 17.2114L15.7122 18.8858C15.9704 19.0381 16.3062 19.0381 16.5903 18.8858L19.5609 17.2114C19.8192 17.0592 20 16.7801 20 16.4757V13.1015C20 12.797 19.845 12.518 19.5609 12.3658L16.5645 10.666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.9985cfbd1d7ac4efc6980579075cb552.svg";
export { ForwardRef as ReactComponent };